import axios from 'axios'
import React, { useEffect, useState } from 'react'

import { getUrlParam } from 'core-components/helpers/url'
import { NotificationController } from 'core-components/library/popup'
import { omnicomProxy } from 'omnicom/utils/omnicomProxy'
import { Common } from 'src/core/imgStore'
import Logger from 'src/modules/core/utils/Logger'

import styles from './UnsubscribeMe.module.scss'

export const UnsubscribeMe = () => {
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    setLoading(true)
    axios
      .post(
        omnicomProxy('/api/v0/emailsLink/unsubscribe'),
        {
          pdlUID: getUrlParam('PDLUID') || null,
          pdlId: +getUrlParam('PDLEntryId') || null,
        },
        { withCredentials: true }
      )
      .then(({ data }) => {
        const responseInfo = data.data
        if (responseInfo.success) {
          NotificationController.showSuccess({ message: responseInfo.message })
        }
      })
      .catch((err) => {
        const responseInfo = err.response.data.data
        NotificationController.showError({ message: responseInfo.message })
        Logger.error(responseInfo.message)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <div
      className={styles.root}
      style={{
        backgroundImage:
          'url("https://res.cloudinary.com/appbuilder/image/fetch/c_fill,g_auto,f_auto/https://app-designer-stg.hpcloud.hp.com/form/553/links/7715/File/Image20220527160234.jpg")',
      }}
    >
      <img className={styles.logo} src={Common['hp-logo']} alt="HP" />
      <div className={styles.message}>
        {loading ? (
          'Wait...'
        ) : (
          <>
            You are unsubscribed from the selected list.
            <br />
            Thank you.
          </>
        )}
      </div>
    </div>
  )
}
